import { useMemo } from "react";
import { useDataTableQuery } from "@/components/data-table/hooks/useDataTableQuery";
import { useSelectedTableRows } from "@/components/data-table/hooks/useSelectedTableRows";
import { useContractorCardsBulkDownload } from "../hooks/useContractorCardsBulkDownload";
import { AsyncOperationProgress } from "@/components/progress/AsyncOperationProgress";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { OperationProgressStatus } from "@/components/progress/AsyncOperationProgress";
import { SuccessFetchListResponse } from "@/services/api";
import { ReadContractorCard } from "@/types/contractorCard";
import { ContractorCardsDownloadButton } from "./ContractorCardsDownloadButton";

export function ContractorCardsDownloadContent() {
  const { query } =
    useDataTableQuery<SuccessFetchListResponse<ReadContractorCard>>();
  const cards = useSelectedTableRows<ReadContractorCard>();

  const { downloadBulk, cancel, operationProgress } =
    useContractorCardsBulkDownload({ cards });

  const isBusy = operationProgress.isBusy();

  const hasDownloadableCards = useMemo(
    () => cards.some((c) => c.card_s3_key && c.card_filename),
    [cards],
  );

  return (
    <>
      {!query.isLoading && (
        <ContractorCardsDownloadButton
          onDownload={downloadBulk}
          disabled={isBusy || !hasDownloadableCards}
          showTooltip={!isBusy && !hasDownloadableCards}
        />
      )}
      <Dialog
        open={operationProgress.status !== OperationProgressStatus.IDLE}
        onOpenChange={(open) => {
          if (!open && !isBusy) {
            operationProgress.reset();
          }
        }}
      >
        <DialogContent className="sm:max-w-4xl max-h-[90vh] flex flex-col">
          <AsyncOperationProgress
            operationProgress={operationProgress}
            translationKey="contractorCards.download"
            onClose={() => operationProgress.reset()}
            onCancel={cancel}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
